import axios from 'axios';
import { CLIENTES_ENDPOINT } from 'cfgCommon/endpoints'
import { composePhone } from 'src/features/common/phone/phoneUtils'

export async function checkForExistingClient(body) {
  try {
    const payload = {
      ...body,
      phone: composePhone(body.phoneCountryCode, body.phone) || body.phone,
    }
    const {data} = await axios.post(`${CLIENTES_ENDPOINT}/clientExists`, payload)
    return data.found
  } catch (error) {
    console.log(error)
  }
}